// Core
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Pages
import { Navigation } from 'src/features/layout/Navigation';
import { HosLog } from 'src/features/hosLogs/hosLog/HosLog';
import { HosLogs } from 'src/features/hosLogs/HosLogs';
import { Header } from 'src/features/layout';
import { PermissionDenied } from 'src/features/auth/permissionDenied/PermissionDenied';
import { MessagesWrapper } from '../features/messages';

// Selectors
import { getHasPermission } from 'src/features/auth/store/authSelectors';
import { Loading } from 'src/features/loading/Loading';
import { Movements } from 'src/features/movements/claimMovements/Movements';

export const Private: React.FC = () => {
  const hasPermission = useSelector(getHasPermission);

  return (
    <>
      {hasPermission ? (
        <>
          <Header />
          <Switch>
            <Route path={'/hos-log/:date'} component={HosLog} />
            <Route path={'/messages'} component={MessagesWrapper} />
            <Route path={'/navigation'} component={Navigation} />
            <Route path={'/hos-logs'} exact component={HosLogs} />
            <Route path={'/movements'} exact component={Movements} />
            <Redirect to={'/hos-logs'} />
          </Switch>
        </>
      ) : (
        <>{hasPermission === undefined ? <Loading /> : <PermissionDenied />}</>
      )}
    </>
  );
};
